import { type FC, useMemo } from 'react';
import { MediaItem, Text } from '@direct-frontend/components';
import { type OpenApiSchemaMediaItemV2 } from '#shared/api/schema';
import { AdaptiveMedia } from '#shared/components/AdaptiveImage';
import { ImageBlank } from '#shared/components/ImageBlank';
import { format } from '#shared/lib/string';

export type ProductCardForGallery = {
    id: string;
    name: string;
    priceFrom: string | number;
    priceTo?: string | number;
    media?: OpenApiSchemaMediaItemV2;
};

export const CardsGalleryItem: FC<ProductCardForGallery> = ({ name, priceFrom, priceTo, media }) => {
    const price = useMemo(() => {
        if (!priceTo) {
            return format(priceFrom, 'price');
        }

        const priceFromString = format(priceFrom, 'price');
        const priceToString = format(priceTo, 'price');

        if (priceFromString === priceToString) {
            return priceFromString;
        }

        return priceFromString + ' — ' + priceToString;
    }, [priceFrom, priceTo]);

    return (
        <MediaItem
            borderRadius="10"
            controls={<></>}
            title={
                <Text maxLines={4} size="s">
                    {name}
                </Text>
            }
            caption={price}
            media={
                media ? (
                    <AdaptiveMedia
                        borderRadius="10"
                        fit="contain"
                        width={120}
                        height={120}
                        media={media}
                        alt={name}
                        background="gray"
                        loading="lazy"
                    />
                ) : (
                    <ImageBlank width={120} height={120} background="gray" borderRadius="10" />
                )
            }
        />
    );
};
